import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";

const tagAdapter = createEntityAdapter({});

const initialState = tagAdapter.getInitialState();

export const useTagApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTag: builder.query({
      query: () => ({
        url: "/tag",
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
      transformResponse: (responseData) => {
        const loadedUsers = responseData.map((user) => {
          user.id = user._id;
          return user;
        });
        return tagAdapter.setAll(initialState, loadedUsers);
      },
      providesTags: (result, error, arg) => {
        if (result?.ids) {
          return [
            { type: "Tag", id: "LIST" },
            ...result.ids.map((id) => ({ type: "Tag", id })),
          ];
        } else return [{ type: "Tag", id: "LIST" }];
      },
    }),
    getOneTag: builder.query({
      //Uzima iz kesha ako ima usera
      query: (id) => ({
        url: `/tag/${id}`,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
      transformResponse: (responseData) => {
        const user = { ...responseData, id: responseData._id };
        return user;
      },
      providesTags: (result, error, arg) => {
        return result ? [{ type: "Tag", id: result.id }] : [];
      },
    }),
    //
    getAllTagBlog: builder.query({
      query: () => ({
        url: "/tag/names",
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
    }),
    addNewTag: builder.mutation({
      query: (initialUserData) => ({
        url: "/tag",
        method: "POST",
        body: {
          ...initialUserData,
        },
      }),
      invalidatesTags: [{ type: "Tag", id: "LIST" }],
    }),
    updateTag: builder.mutation({
      query: (initialUserData) => ({
        url: "/tag",
        method: "PATCH",
        body: {
          ...initialUserData,
        },
      }),
      invalidatesTags: (result, error, arg) => [{ type: "Tag", id: arg.id }],
    }),
    deleteTag: builder.mutation({
      query: ({ id }) => ({
        url: `/tag`,
        method: "DELETE",
        body: { id },
      }),
      invalidatesTags: (result, error, arg) => [{ type: "Tag", id: arg.id }],
    }),
  }),
});

export const {
  useGetTagQuery,
  useAddNewTagMutation,
  useDeleteTagMutation,
  useUpdateTagMutation,
} = useTagApiSlice;
